import React from 'react'
import './OperationBtn2.less'

const RightBtn = ({ added, onClick }) => {
    return <div className={`operate ${added?'added':''}`} onClick={onClick}>
        <i className={`icon-operation ${added ? 'added' : ''}`} />
        {added?'已选':'选择'}
    </div>
}
export default RightBtn








// WEBPACK FOOTER //
// ./src/pages/SchoolWishList/OperationBtn2.js